import React, { useCallback } from 'react';

export const useScrollbar = () => {
  const scrollbarColor = 'var(--sf-color-gray-10)';
  const handleMouseEnter = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.currentTarget.style.scrollbarColor = `${scrollbarColor} transparent`;
    },
    [scrollbarColor],
  );

  const handleMouseLeave = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.scrollbarColor = 'transparent transparent';
  }, []);

  const scrollbarStyle = {
    scrollbarWidth: 'thin' as const,
    scrollbarColor: 'transparent transparent',
    transition: 'scrollbar-color 0.15s ease-in-out',
  };

  return {
    scrollbarStyle,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
  };
};
